(($, Drupal) => {
  (() => {
    if (window.globalErrorHandlerAttached) return;
    window.addEventListener("error", (event) => {
      const { error, filename } = event;
      if (
        filename?.includes("facets-views-ajax.js") &&
        error?.message?.includes(
          "Cannot read properties of undefined (reading 'settings')"
        )
      ) {
        console.warn(
          "Facets AJAX error detected. Reinitializing Drupal behaviors."
        );
        Drupal.attachBehaviors(document, drupalSettings);
      }
    });
    window.globalErrorHandlerAttached = true;
  })();

  Drupal.behaviors.gridItemSelect = {
    attach(context) {
      const grid = document.querySelector(".exam-questions-grid");
      if (!grid) return;

      const handleClick = (event) => {
        const target = event.target.closest(".facet-item");
        if (target?.classList.contains("parent")) return;

        const checkbox = target?.querySelector('input[type="checkbox"]');
        const linkBtn = target?.querySelector(".btn-facet");

        if (
          (checkbox && checkbox.checked) ||
          (linkBtn && linkBtn.classList.contains("is-active"))
        )
          return;

        if (grid) {
          grid.classList.add("grid-filtering");
          scrollToGrid(grid);
        }
      };

      // Ensure no duplicate bindings for click events
      $(document)
        .off("click", ".facet-item")
        .on("click", ".facet-item", handleClick);

      const scrollToGrid = (grid) => {
        if (
          grid.classList.contains("grid-filtering") &&
          typeof grid.offsetTop !== "undefined"
        ) {
          window.scrollTo({ top: grid.offsetTop, behavior: "smooth" });
        } else {
          console.warn("Grid filtering not applied or grid not found.");
        }
      };
    },
  };
})(jQuery, Drupal);
